<template>
<div>
  <table cellpadding="0" cellspacing="0" class="sc-jDwBTQ dWtMUn" style="vertical-align: -webkit-baseline-middle; font-size: medium; font-family: Verdana;">
    <tbody>
      <tr>
        <td style="vertical-align: middle;">
          <table cellpadding="0" cellspacing="0" class="sc-jDwBTQ dWtMUn" style="vertical-align: -webkit-baseline-middle; font-size: medium; font-family: Verdana;">
            <tbody>
              <tr>
                <td>
                  <template v-for="item in mainFields">
                  <h3 v-if="item.name === 'Full name'"
                  color="#666" class="sc-jhAzac hmXDXQ" style="margin: 0px; font-size: 16px; color: rgb(102, 102, 102); line-height: 20px;">
                  <span>{{ item.value }}</span>
                  </h3>
                  </template>
                  <template v-for="item in mainFields">
                  <p v-if="item.name === 'Job title'"
                  color="#666" font-size="medium" class="sc-fBuWsC eeihxG" style="margin: 0px; color: rgb(102, 102, 102); font-size: 12px; line-height: 20px;">
                    <span>{{ item.value }}</span>
                  </p>
                  </template>
                  <p color="#666" font-size="medium" class="sc-fMiknA bxZCMx" style="margin: 0px; font-weight: 500; color: rgb(102, 102, 102); font-size: 12px; line-height: 20px;">
                    <span>Fusebill</span>
                  </p>
                </td>
                <td width="15">
                  <div></div>
                </td>
                <td width="1" color="#b3b3b3" direction="vertical" class="sc-hzDkRC kpsoyz" style="width: 1px; border-bottom: none; border-left: 1px solid rgb(179, 179, 179);"></td>
                <td width="15">
                  <div></div>
                </td>
                <td>
                  <table cellpadding="0" cellspacing="0" class="sc-jDwBTQ dWtMUn" style="vertical-align: -webkit-baseline-middle; font-size: medium; font-family: Verdana;">
                    <tbody>
                      <template v-for="item in otherFields">
                      <tr v-if="item.name === 'Phone' && item.value" 
                      height="20" style="vertical-align: middle;">
                        <td width="30" style="vertical-align: middle;">
                          <table cellpadding="0" cellspacing="0" class="sc-jDwBTQ dWtMUn" style="vertical-align: -webkit-baseline-middle; font-size: medium; font-family: Verdana;">
                            <tbody>
                              <tr height="20" style="height:20px">
                                <td style="vertical-align: bottom;">
                                  <span width="13" height="13" class="sc-iRbamj blSEcj" style="display: block;height:13px">
                                    <img width="13" height="13" src="https://cdn2.hubspot.net/hubfs/547412/Email%20Signature/phone-icon-2x.png" color="#f8a65c" class="sc-gPEVay eQYmiW" style="display: block;">
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td v-if="item.name === 'Phone'"
                        style="padding: 0px; color: rgb(102, 102, 102);">
                          <a :href="`tel:${item.value}`" color="#1f2537" class="sc-jlyJG bbyJzT" style="text-decoration: none; color: #666; font-size: 11px;">
                              <span>{{ item.value }}</span>
                            </a>
                        </td>
                      </tr>
                      </template>
                      <template v-for="item in otherFields">
                      <tr v-if="item.name === 'Email' && item.value"
                        height="20" style="vertical-align: middle;">
                        <td width="30" style="vertical-align: middle;">
                          <table cellpadding="0" cellspacing="0" class="sc-jDwBTQ dWtMUn" style="vertical-align: -webkit-baseline-middle; font-size: medium; font-family: Verdana;">
                            <tbody>
                              <tr height="20" style="height:20px">
                                <td style="vertical-align: bottom;">
                                  <span width="13" height="13"   style="display: block;height:13px; ">
                                    <img width="13" height="13" src="https://cdn2.hubspot.net/hubfs/547412/Email%20Signature/email-icon-2x.png" color="#f8a65c" class="sc-gPEVay eQYmiW" style="display: block;">
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td style="padding: 0px;">
                          <a :href="`mailto:${item.value}`" color="#1f2537" class="sc-jlyJG bbyJzT" style="text-decoration: none; color: #666; font-size: 11px;">
                                <span>{{ item.value }}</span>
                              </a>
                        </td>
                      </tr>
                      </template>
                      <tr height="20" style="height:20px; vertical-align: middle;">
                        <td width="30" style="vertical-align: middle;">
                          <table cellpadding="0" cellspacing="0" class="sc-jDwBTQ dWtMUn" style="vertical-align: -webkit-baseline-middle; font-size: medium; font-family: Verdana;">
                            <tbody>
                              <tr height="20" style="height:20px">
                                <td style="vertical-align: bottom;">
                                  <span width="13"  height="13"  class="sc-iRbamj blSEcj" style="display: block; height:13px; ">
                                    <img width="13" height="13" src="https://cdn2.hubspot.net/hubfs/547412/Email%20Signature/link-icon-2x.png" color="#f8a65c" class="sc-gPEVay eQYmiW" style="display: block;">
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td style="padding: 0px;">
                          <a href="//www.fusebill.com" color="#1f2537" class="sc-jlyJG bbyJzT" style="text-decoration: none; color: rgb(102, 102, 102); font-size: 11px;">
                            <span>www.fusebill.com</span>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td height="19"></td>
      </tr>
      <tr>
        <td height="1" color="#b3b3b3" direction="horizontal" class="sc-hzDkRC kpsoyz" style="width: 100%; border-bottom: 1px solid rgb(179, 179, 179); border-left: none; display: block;"></td>
      </tr>
      <tr>
        <td height="16"></td>
      </tr>
      <tr>
        <td>
          <table cellpadding="0" cellspacing="0" class="sc-jDwBTQ dWtMUn" style="vertical-align: -webkit-baseline-middle; font-size: medium; font-family: Verdana; width: 100%;">
            <tbody>
              <tr>
                <td style="vertical-align: top;">
                  <img width="70" height="29" src="https://cdn2.hubspot.net/hubfs/547412/Email%20Signature/gray_orange_fusebill.png?version=002" role="presentation" class="sc-kjoXOD hpTAeq" style="max-width: 70px; width:70px; height: 29px; display: block;">
                </td>
                <td style="text-align: right; vertical-align: top;">
                  <table cellpadding="0" cellspacing="0" class="sc-jDwBTQ dWtMUn" style="vertical-align: -webkit-baseline-middle; font-size: medium; font-family: Verdana; display: inline-block; margin-top: 0px;">
                    <tbody>
                      <tr style="text-align: right;">
                        <td>
                          <a href="https://www.linkedin.com/company/fusebill" color="#f6851f" class="sc-bRBYWo ccSRck" style="display: inline-block; padding: 0px;">
                            <img height="24" width="24" src="https://cdn2.hubspot.net/hubfs/547412/Email%20Signature/linkedin-icon-2x.png" alt="linkedin" color="#f6851f" class="sc-Rmtcm gwGgYM" style="max-width: 135px; display: block;">
                          </a>
                        </td>
                        <td width="5">
                          <div></div>
                        </td>
                        <td>
                          <a href="https://twitter.com/fusebill" color="#f6851f" class="sc-bRBYWo ccSRck" style="display: inline-block; padding: 0px;">
                            <img height="24" width="24" src="https://cdn2.hubspot.net/hubfs/547412/Email%20Signature/twitter-icon-2x.png" alt="twitter" color="#f6851f" class="sc-Rmtcm gwGgYM" style="max-width: 135px; display: block;">
                          </a>
                        </td>
                        <td width="5">
                          <div></div>
                        </td>
                        <td>
                          <a href="https://www.youtube.com/user/Fusebill" color="#f6851f" class="sc-bRBYWo ccSRck" style="display: inline-block; padding: 0px;">
                            <img height="24" width="24" src="https://cdn2.hubspot.net/hubfs/547412/Email%20Signature/youtube-icon-2x.png" alt="instagram" color="#f6851f" class="sc-Rmtcm gwGgYM" style="max-width: 135px; display: block;">
                          </a>
                        </td>
                        <td width="5">
                          <div></div>
                        </td>
                        <td>
                          <a href="https://www.facebook.com/Fusebill" color="#f6851f" class="sc-bRBYWo ccSRck" style="display: inline-block; padding: 0px;">
                            <img height="24" width="24" src="https://cdn2.hubspot.net/hubfs/547412/Email%20Signature/facebook-icon-2x.png" alt="facebook" color="#f6851f" class="sc-Rmtcm gwGgYM" style="max-width: 135px; display: block;">
                          </a>
                        </td>
                        <td width="5">
                          <div></div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td height="8"></td>
      </tr>
      <tr>
        <td height="1" color="#b3b3b3" direction="horizontal" class="sc-hzDkRC kpsoyz" style="width: 100%; border-bottom: 1px solid rgb(179, 179, 179); border-left: none; display: block;"></td>
      </tr>
      <tr>
        <td height="60" style="text-align: center;">
          <a href="https://www.fusebill.com/are-you-ready-for-billing-automation" style="color: rgb(179, 179, 179); display: inline-block; font-family: sans-serif; font-size: 12px; font-weight: bold; line-height: 60px; text-align: center; width: 100%; text-size-adjust: none; letter-spacing: 0.07em;">Are You Ready For Automated Billing?</a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
</template>

<script>
import EmailTemplate from './emailTemplate'
import Avatar from './components/Avatar'
import PromoteSignature from './components/PromoteSignature'
import BannerPlaceholder from './components/BannerPlaceholder'

export default {
  components: {
    Avatar,
    PromoteSignature,
    BannerPlaceholder
  },
  extends: EmailTemplate
}
</script>
